import React, {Component} from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';

import './VideoSelectionMenu.scss';

import SwapIcon from '../../../assets/icons/swap.svg';

// One item component
// selected prop will be passed
const MenuItem = ({ data, selected }) => {
	return (
		<div
			className={`videoSelectItem`}
		>
			<div className={`videoSelectItem__content ${selected ? `videoSelectItem__content--selected` : ``}`}>
				<img
					src={data.thumbnail}
					alt={data.name}
					className={`videoSelectItem__thumbnailImage ${selected ? `videoSelectItem__thumbnailImage--selected` : ``}`}
					onDragStart={(e) => e.preventDefault()}
				/>
				<span className={`videoSelectItem__name ${selected ? `videoSelectItem__name--selected` : ``}`} >
					{data.name}
				</span>

				<div className={`videoSelectItem__hoverContent`}>
					<img
						src={SwapIcon}
						alt={`swap`}
						className={`videoSelectItem__swapIcon`}
						onDragStart={(e) => e.preventDefault()}
					/>
					<span className={`videoSelectItem__hoverText`}>
						SWITCH TO {data.name.toUpperCase()}
					</span>
				</div>
			</div>
		</div>
	);
};
// All items component
// Important! add unique key
export const Menu = (list) => {
	return list.map((el,index) => {
		return (
			<MenuItem
				data={el}
				key={index}
			/>
		);
	})
};


const Arrow = ({ text, className }) => {
	return (
		<div
			className={className}
		>{text}</div>
	);
};


const ArrowLeft = Arrow({ text: '', className: 'videoSelectNavArrow videoSelectNavArrow--previous' });
const ArrowRight = Arrow({ text: '', className: 'videoSelectNavArrow videoSelectNavArrow--next' });

class VideoSelectionMenu extends Component {

	render() {
		return (
			<ScrollMenu
				menuClass={`videoSelectMenu`}
				data={Menu(this.props.videos, this.props.selected)}
				arrowLeft={ArrowLeft}
				arrowRight={ArrowRight}
				selected={this.props.selected}
				onSelect={this.props.onSelect}
				hideArrows={true}
				// hideSingleArrow={true}
				itemClass={`videoSelectItemWrapper ${this.props.open ?  `videoSelectItemWrapper--open` : ''}`}
			/>
		)
	}
}

export default VideoSelectionMenu;